import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchAccountOptions } from '@/renderer/services/accountingService';

export function useAccountOptions(companyId: number | null) {
  return useQuery({
    queryKey: queryKeys.accounting.accountOptions(companyId ?? 0),
    queryFn: async () => {
      const result = await fetchAccountOptions(companyId!);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch account options');
      }
      return result.data;
    },
    enabled: !!companyId,
    staleTime: 1000 * 60 * 15,
  });
}
